import { FloorTypename } from "shared/types/Project"

import { useAttachmentsByShareLinkQuery } from "entities/attachments/api/useAttachmentsByShareLinkQuery"
import { useProjectAttachmentsByShareLinkQuery } from "entities/attachments/graphql/project-attachments.queries.generated"
import { useAggregatedFloorData } from "entities/floors/api/useAggregatedFloorData"

import { FloorModel } from "../types/FloorModel"

export interface UseSharedFloorOptions {
  includePrice?: boolean
}

export function useSharedFloor({
  floorID,
  projectID,
  options
}: {
  floorID: string
  projectID: string
  options?: UseSharedFloorOptions
}): FloorModel {
  const data = useAggregatedFloorData({
    floorID,
    projectID,
    options: { includePrice: options?.includePrice, isShared: true }
  })

  const {
    data: linkedAttachmentsData,
    loading: isLoadingLinkedAttachments,
    error: linkedAttachmentsError
  } = useAttachmentsByShareLinkQuery({
    id: floorID,
    projectShareID: projectID,
    resourceType: FloorTypename
  })

  const {
    data: attachmentsData,
    loading: isLoadingAttachments,
    error: attachmentsError
  } = useProjectAttachmentsByShareLinkQuery({
    variables: { id: projectID }
  })

  return {
    core: {
      data: { floor: data.floor },
      handlers: {
        onEdit: undefined,
        onDelete: undefined,
        onDuplicate: undefined,
        onCopy: undefined,
        onAddClarificationRequest: undefined
      }
    },
    pricing: {
      data: { price: data.price }
    },
    clarificationRequest: null,
    attachments: {
      data: {
        linkedAttachments: {
          data: linkedAttachmentsData?.attachmentsByShareLink,
          isLoading: isLoadingLinkedAttachments,
          isUpdating:
            !!linkedAttachmentsData?.attachmentsByShareLink &&
            isLoadingLinkedAttachments,
          error: !!linkedAttachmentsError
        },
        attachments: {
          data: attachmentsData?.attachments,
          isLoading: isLoadingAttachments,
          isUpdating: !!attachmentsData?.attachments && isLoadingAttachments,
          error: !!attachmentsError
        }
      },
      handlers: { onAssignAttachments: undefined }
    }
  }
}
